import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_database/database-sql-tabelas-monitoradas";

export const Route = createFileRoute("/_authenticated/database-sql-tabelas-monitoradas")({
  head: () => ({
    meta: [
      { title: "Tabelas monitoradas (SQL) — Milky Moo Palmares" },
      { name: "description", content: "Gerenciar tabelas monitoradas do SQL." },
      { property: "og:title", content: "Tabelas monitoradas (SQL) — Milky Moo Palmares" },
      { property: "og:description", content: "Gerenciar tabelas monitoradas do SQL." },
    ],
  }),
  component: PaginaRota,
});
